<template lang="pug">
#show-form.contract-show
  .show-card
    q-card-section
      form-header(
        v-if="show_data.common",
        ref="form-header",
        @close-form="closeShow",
        :parentData="{ grid: grid, title: show_data.common.form_header.title + ' № ' + row_id, title_icon: 'show_header.svg' }"
      )

    .spinner-container.form-spinner(v-if="loading")
      q-spinner(color="primary", size="3em")

    div(v-if="!loading")
      q-card-section
        component(
          ref="actions",
          v-if="show_data.common['actions']",
          :is="getShowComponent('actions')",
          @refresh-table="refreshTable",
          @open-form="openForm",
          @click="onActionClick",
          :parentData="{ row: row, grid: grid, grid_key: grid_key, path: path, transition_key: transition_key, data: show_data.common['actions'] }"
        )

      div
        .qr-preview
          qr-image(:url="qrObject.url")
        qr(
          v-show="false",
          ref="printRef",
          :title="qrObject.form.header",
          :texts="qrObject.form.fields",
          :url="qrObject.url"
        ) 

      q-card-section
        component(
          ref="blocks",
          v-if="show_data.common['blocks']",
          :is="getShowComponent('blocks')",
          :parentData="{ row: row, show_details: false, data: show_data.common['blocks'] }"
        )

      q-card-section
        component(
          ref="tabs",
          v-if="show_data.common['tabs']",
          :is="getShowComponent('tabs')",
          :parentData="{ data: show_data.common['tabs'] }"
        )
</template>

<script>
import { openTabAndPrintContent } from "@/services/print";
import formHeader from "../../../shared/forms/formHeader";
import showComponents from "../../../shared/show_card_components/index";
import qrImage from "../../../shared/print/qrImage";
import qr from "../../../shared/print/qr";
import compiledPrintQrCss from "!raw-loader!sass-loader!../../../../assets/styles/printQr/qr.scss";

export default {
  components: {
    formHeader,
    showComponents,
    qrImage,
    qr,
  },

  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      path: this.parentData.path,
      row_id: this.parentData.row.id,
      row: {},
      item: "meter",
      transition_key: this.parentData.transition_key,
      grid: this.parentData.grid,
      grid_key: this.parentData.grid_key,
      show_data: [],
      loading: true,
    };
  },

  computed: {
    qrObject() {
      return this.show_data.common.qr;
    },
  },

  watch: {
    loading(newVal, oldVal) {
      if ([true, false].includes(newVal)) {
        this.$refs["form-header"]?.setLoading(newVal);
      }
    },
  },

  created() {
    this.$emit("row-is-active", true);
    setTimeout(() => {
      this.loadShowData();
    }, 500);
  },

  beforeDestroy() {
    this.row_id = "";
  },

  methods: {
    setLoading(val) {
      this.loading = val;
    },

    refreshTable(data) {
      this.refreshRow(data);
      this.$emit("refresh-table", data);
      this.$refs.tabs.refreshGrid("products");

      if (data.action === "destroy") {
        this.$emit("close-show", this.row);
      }
    },

    refreshRow(data) {
      this.row = data.attr.data || data.attr;
    },

    openForm(data) {
      this.$emit("open-form", data);
    },

    closeShow(row = this.row) {
      this.$emit("close-show", row);
    },

    onActionClick(name) {
      if (name != "print_qr") {
        return;
      }

      openTabAndPrintContent({ html: this.$refs.printRef.$el.innerHTML, css: compiledPrintQrCss });
    },

    loadShowData(params = {}) {
      this.$backend
        .show(this.path, this.row_id, { params: params })
        .then(({ data }) => {
          this.show_data = data;
          this.row = this.show_data.common["data"];
        })
        .catch(error => {
          console.log(error);
          if (error.response) {
            this.reLogin(error.response.status);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../assets/styles/show/contract/main";

.show-card {
  .qr {
    background: #fff;
    width: 195px;
    height: 195px;
    padding: 15px;
    margin-left: 30px;
    border-radius: 5px;
  }
}

.qr-preview {
  display: flex;
  justify-content: center;
}
</style>
